import React, { Component } from "react"

import UserListItemShadow from "./UserListItemShadow"
import ListItemImageShadow from "./content-loading/ListItemImageShadow"
import ContentLines from "./content-loading/ContentLines"
import ContentTags from "./content-loading/ContentTags"
import { randomInt } from "../../config/util-functions"

export default class PermissionHolderListItemShadow extends Component {
    state = {
        isUser: randomInt(0, 2) === 1 ? true : false
    }

    render() {
        const { isUser } = this.state

        if (isUser) {
            return <UserListItemShadow {...this.props} />
        } else {
            return (
                <div className="list-group-item">
                    <ListItemImageShadow />
                    <div className="list-group-item-content">
                        <ContentLines />
                        <ContentLines minLineLength={30} />
                        <ContentTags tags={1} />
                    </div>
                </div>
            )
        }
    }
}
